import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Box,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { withTranslation } from 'react-i18next';
import styles from './styles'
import {roundToFixed} from "../../../services/util/helperFuncs";

function TemplateAggregationCard(props) {
  const { templates, t } = props;

  const [expanded, setExpanded] = useState(false);

  const totalLength = templates.reduce(
      (sum, template) => sum + (template.distanceInKm || 0),
      0
  );

  const shops = templates.reduce((total, template) => {
    const count = (template.stops || []).filter(
        (stop) => stop.stopType === 0
    ).length;
    return total + count;
  }, 0);

  const chests = templates.reduce((total, template) => {
    const count = (template.stops || []).filter(
        (stop) => stop.stopType === 1
    ).length;
    return total + count;
  }, 0);

  const driveTime = templates.reduce(
      (sum, template) => sum + template.travelDurationInMin ?? 0,
      0
  );

  const dwellTime = templates.reduce(
      (sum, template) => sum + template.dwellTimeDurationInMin ?? 0,
      0
  )

  const totalTime = driveTime + dwellTime;

  return (
      <Card elevation={3} style={{ marginBottom: '16px' }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <strong>{t('aggregatedCardTitle')}</strong>
            <IconButton
                onClick={() => setExpanded((prev) => !prev)}
                size="small"
                aria-label={expanded ? t('collapse') : t('expand')}
            >
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>

          {expanded && (
              <Grid container>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                    <strong>{t('length')}</strong>: {roundToFixed(totalLength, 1)}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                    <strong>{t('duration')}</strong>: {roundToFixed(totalTime, 1)}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                    <strong>{t('shops')}</strong>: {shops}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                    <strong>{t('chests')}</strong>: {chests}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                    <strong>{t('dwellTime')}</strong>: {roundToFixed(dwellTime, 0)}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                    <strong>{t('driveTime')}</strong>: {roundToFixed(driveTime, 0)}
                  </div>
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.aggregatedInformation}>
                      <strong>{t('tours')}</strong>: {templates.length}
                  </div>
                </Grid>
              </Grid>
          )}
        </CardContent>
      </Card>
  );
}

TemplateAggregationCard.propTypes = {
  templates: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TemplateAggregationCard);
